module.exports = __webpack_public_path__ + "img/public/SiteIcons/editProfileIcon.svg?3cb44533";